const software = {
  title: "WallPen OS 3.0 – The Pro Software Upgrade",
  description:
    "WallPen OS 3.0 is the most advanced vertical printing software, seamlessly integrated with the WallPen E2 Pro to deliver unmatched precision, automation, and efficiency.",

  heroImage: "https://picsum.photos/id/1005/1600/900",
  videoUrl:
    "https://www.youtube.com/watch?v=Uv6hQSOTDsI&ab_channel=wallPenGmbH",

  whyUpgrade: [
    {
      title: "Unmatched Precision",
      description:
        "With features like Skip Swath, Laser Look-Ahead, and Start at Laser, achieve perfectly aligned prints every time.",
      icon: "ShieldCheckIcon",
    },
    {
      title: "AI-Powered Automation",
      description:
        "Save time with automation that optimizes workflow and eliminates manual adjustments.",
      icon: "ArrowPathIcon",
    },
    {
      title: "Multi-Device Compatibility",
      description:
        "Control your wallPen from any device, including iOS, Android, macOS, Windows, and iPad.",
      icon: "CpuChipIcon",
    },
  ],

  comparison: [
    {
      feature: "Multi-Device Compatibility",
      standard: false,
      pro: true,
      description:
        "Control your wallPen from <strong>any device</strong>, including <strong>iOS, Android, Windows, macOS, and iPad</strong>. No need for dedicated controllers—print directly from your smartphone, tablet, or PC.",
    },
    {
      feature: "Wireless File Transfer",
      standard: false,
      pro: true,
      description:
        "Instantly send print jobs via <strong>5GHz WiFi</strong> without relying on USB or cables. Retrieve files and update designs remotely for <strong>seamless workflow efficiency</strong>.",
    },
    {
      feature: "Skip Swath Automation",
      standard: false,
      pro: true,
      description:
        "Automatically <strong>detects unprinted sections</strong> and skips unnecessary movements—significantly <strong>reducing print time</strong> and improving efficiency.",
    },
    {
      feature: "Laser Look-Ahead",
      standard: false,
      pro: true,
      description:
        "Smart scanning technology <strong>memorizes wall surfaces</strong>, avoiding obstacles and ensuring <strong>flawless execution</strong> without requiring constant manual supervision.",
    },
    {
      feature: "Corner-to-Corner Printing",
      standard: false,
      pro: true,
      description:
        "Resume prints <strong>seamlessly across surfaces</strong> with precise alignment, preventing <strong>overlapping or gaps</strong> between print jobs.",
    },
    {
      feature: "Direct Wall Distance Control",
      standard: false,
      pro: true,
      description:
        "Automatically adjusts the <strong>printhead distance</strong> to <strong>prevent wall contact</strong> and optimize print quality, especially on <strong>uneven surfaces</strong>.",
    },
    {
      feature: "Over-the-Air Updates",
      standard: false,
      pro: true,
      description:
        "Unlike cheap printers with outdated software, WallPen OS 3.0 <strong>continuously improves</strong> with <strong>automatic updates</strong>, ensuring you always have the latest features and optimizations.",
    },
    {
      feature: "Job History & Repeat Printing",
      standard: true,
      pro: true,
      description:
        "Save and <strong>reproduce previous print jobs</strong> effortlessly, allowing for <strong>quick reprints</strong> without manual setup.",
    },
    {
      feature: "Real-Time Adjustments",
      standard: true,
      pro: true,
      description:
        "Modify settings like <strong>scaling, positioning, and alignment</strong> <strong>on the fly</strong>, even while a job is in progress.",
    },
  ],

  callToAction: {
    title: "Upgrade to WallPen OS 3.0",
    description:
      "Experience the ultimate vertical printing software. Unlock advanced features, automation, and precision for your printing business.",
  },
};

export default software;
